import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  meta: {
    pageNumber: 1,
    pageSize: 20,
    itemTotal: 0,
  },
  list: [],
  reports: [],
  selectedBankUpdate: {
    bank: {
      _id: undefined,
    },
    files: [],
  },
  bankUpdateAdded: false,
  bankUpdateUpdated: false,
  bankUpdateRemoved: false,
};

const bankUpdatesSlice = createSlice({
  name: "bankUpdates",
  initialState,
  reducers: {
    getBankUpdates(state, action) {
      state.list = action.payload.bankUpdates;
      state.meta = action.payload.meta;
    },
    getBankUpdatesById(state, action) {
      state.selectedBankUpdate = action.payload;
    },
    addBankUpdates(state, action) {
      state.bankUpdateAdded = true;
    },
    updateBankUpdates(state, action) {
      state.bankUpdateUpdated = true;
    },
    removeBankUpdates(state, action) {
      state.bankUpdateRemoved = true;
    },
    reset: (state) => initialState,
    logout: (state) => initialState,
  },
});

export const banksUpdatesActions = bankUpdatesSlice.actions;
export default bankUpdatesSlice;
